import requester from '@/lib/axios';
import TokenBalance from '@/models/astro.ai/astrobot/TokenBalance';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

const baseUrl = 'astro-ai/tokens';

export type ListTokensBalanceFilters = {
  userId?: number;
} & BaseFilters;

export const listTokensBalance = async (
  params: ListTokensBalanceFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<TokenBalance>>(
    `${baseUrl}/`,
    {
      params,
    },
  );
  return data;
};

export const getTokenBalance = async (id: number) => {
  const { data } = await requester().get<TokenBalance>(`${baseUrl}/${id}/`);
  return data;
};

export const getUserTokenBalance = async () => {
  const { data } = await requester().get<TokenBalance>(`${baseUrl}/balance/`);
  return data;
};

export const updateTokenBalance = async (
  id: number,
  tokenBalance: Partial<TokenBalance>,
) => {
  const { data } = await requester().patch<TokenBalance>(
    `${baseUrl}/${id}/`,
    tokenBalance,
  );
  return data;
};
